<template>
  <div class="table table-bg">
    <div class="table-header center">
      <div class="table-tlt center-left">
        <h2>회사 등록</h2>
      </div>
      <div class="table-btn center-right">
        <div>
          <button class="btn btn-140" @click="goList">회사 리스트</button>
        </div>
      </div>
    </div>
    <div class="table-desc">
      <div class="table-content">
        <table>
          <tr>
            <td class="header">회사 ID</td>
            <!-- TODO <td><input type="text" v-model="company.companyAlias" /></td> -->
            <td>-자동생성-</td>
          </tr>
          <tr>
            <td class="header">사업자 번호</td>
            <td><input type="text" v-model="company.registrationNo" /></td>
          </tr>
          <tr>
            <td class="header">모회사</td>
            <td>
              <div v-if="company.scope && company.scope > 2">
                <select v-model="company.parentCompanyID">
                  <option v-for="item in parentCompanyList" :key="item.companyID" :value="item.companyID">
                    {{ item.companyName }}
                  </option>
                </select>
              </div>
              <div v-else>-</div>
            </td>
          </tr>
        </table>
        <div class="vertical-line"></div>
        <table>
          <tr>
            <td class="header">회사 이름 <font style="color:red;">*</font></td>
            <td><input type="text" v-model="company.companyName" /></td>
          </tr>
          <tr>
            <td class="header">역할 <font style="color:red;">*</font></td>
            <td>
              <select v-model="company.scope" @change="changeScope(company.scope)">
                <option v-for="item in companyScope" :key="item.code" :value="item.code">
                  {{ item.name }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="header"></td>
            <td></td>
          </tr>
        </table>
      </div>
      <div class="table-btn center">
        <butto class="btn btn-140 btn-blue-line" @click="excuteUpdate">
          <span v-if="!processing" class="process">등록</span>
          <ButtonLoading v-else></ButtonLoading>
        </butto>
        <button
          class="btn btn-right"
          @click="cancelUpdate"
        >취소</button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */

import Configuration from '@/js/Configuration';
import ButtonLoading from '@/components/include/ButtonLoading';

export default {
  components: {
    ButtonLoading,
  },
  data: () => ({
    companyScope: [],
    company: {
      companyName: null,
      companyAlias: null,
      registrationNo: null,
      scope: null,
    },
    parentCompanyList: [],
    processing: false,
  }),
  created() {
    const token = this.$jwtDecode(this.$cookie.get('accessToken'));
    this.scope = token.scope;
    this.role = token.role;

    for (let i = 1; i < this.$companyScope.length; i++) {
      if (i > 1) {
        this.companyScope.push(this.$companyScope[i]);
      } else if (i === 1 && (
        (this.scope === 1 && this.role === 1) ||
        (this.scope === 2 && this.role === 1)
      )) {
        this.companyScope.push(this.$companyScope[i]);
      }
    }
  },
  methods: {
    async changeScope(scope) {
      this.parentCompanyList = [];

      try {
        const url = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/company/list?page=1&limit=500`;

        const list = await this.$http.get(url, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (list.status !== 200) {
          if (list.status === 204) {
            return;
          }
        }

        const companyList = [];
        for (let i = 0; i < list.data.companies.length; i++) {
          const p = list.data.companies[i];

          if (p.scope === scope - 1) {
            companyList.push(p);
          }
        }

        this.parentCompanyList = companyList;
      } catch (e) {
        this.parentCompanyList = [];
        console.error(e);
      }
    },
    async excuteUpdate() {
      try {
        this.processing = true;
        const url = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/company`;

        const param = this.company;
        const createResult = await this.$http.post(url,
          param,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          });
        if (createResult.status !== 200) {
          throw new Error(`Response status is "${createResult.status}"`);
        }
        if (createResult.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${createResult.data.resultCode}"`);
        }

        this.processing = false;
        this.$emit('refreshList', null, 'all', 1);
      } catch (e) {
        this.processing = false;
        console.error(e);
      }
    },
    cancelUpdate() {
      this.$emit('refreshList', null, 'all');
    },
    goList() {
      this.cancelUpdate();
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/account/company/CompanyCreate.vue